import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);

    return (
        <nav className="navbar">
            {/* Decorative Left */}
            <div className="nav-decor-left">
                <img src="images/leaf.webp" className="decor-shape shape-1" alt="" />
                <img src="images/leaf.webp" className="decor-shape shape-2" alt="" />
                <img src="images/leaf.webp" className="decor-shape shape-5" alt="" />
                {/* <img src="images/leaf.webp" className="decor-shape shape-6" alt="" /> */}
            </div>

            <div className="nav-inner">

                {/* LEFT: Logo Section */}
                <div className="logo">
                    <Link to="/" className="logo-link">
                        <img src="images/logo.webp" alt="Logo" className="logo-img" />
                    </Link>
                </div>

                {/* RIGHT: Desktop Nav + Actions */}
                <div className="nav-right">

                    {/* Desktop Links (Hidden on Mobile) */}
                    <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
                        <li><Link to="/" onClick={() => setIsOpen(false)}>Home</Link></li>
                        <li><Link to="/collection" onClick={() => setIsOpen(false)}>Collection</Link></li>
                        <li><Link to="/about" onClick={() => setIsOpen(false)}>About</Link></li>
                        <li><Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link></li>

                    </ul>

                    {/* Round Hamburger (Mobile Only) */}
                    <button
                        className={`hamburger-btn ${isOpen ? 'open' : ''}`}
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        <div className="hamburger-lines"></div>
                    </button>
                </div>

            </div>

            {/* Decorative Right */}
            <div className="nav-decor-right">
                <img src="images/leaf.webp" className="decor-shape shape-3" alt="" />
                <img src="images/leaf.webp" className="decor-shape shape-4" alt="" />
                <img src="images/leaf.webp" className="decor-shape shape-7" alt="" />
                {/* <img src="images/leaf.webp" className="decor-shape shape-8" alt="" /> */}
            </div>
        </nav>
    );
}